/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  ApiErrorDTO,
  BadRequestResponse,
  ConflictResponse,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetVerificationCodeBatchesParams,
  InternalServerErrorResponse,
  PaginatedVerificationCodeBatchListItemsDTO,
  UnauthorizedResponse,
  VerificationCodeBatchListItemDTO,
  VerificationCodeCreateBody,
  VerificationCodeInviteCheckResponseDTO,
  VerificationCodeInviteCreateDTO,
  VerificationCodeInviteCreateResponseDTO,
  VerificationCodeUseDTO,
  VerificationCodeUseResponseDTO,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns all batches matching the filter criteria. All given filter will be combined as AND criteria
 * @summary Returns a paginated List of all Verification Code Batches
 */
export type getVerificationCodeBatchesResponse = {
  data: PaginatedVerificationCodeBatchListItemsDTO;
  status: number;
};

export const getGetVerificationCodeBatchesUrl = (
  params?: GetVerificationCodeBatchesParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/verification-codes/batches?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/verification-codes/batches`;
};

export const getVerificationCodeBatches = async (
  params?: GetVerificationCodeBatchesParams,
  options?: RequestInit
): Promise<getVerificationCodeBatchesResponse> => {
  return customFetchInstance<Promise<getVerificationCodeBatchesResponse>>(
    getGetVerificationCodeBatchesUrl(params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetVerificationCodeBatchesQueryKey = (
  params?: GetVerificationCodeBatchesParams
) => {
  return [
    `http://localhost:8080/platform/v1/verification-codes/batches`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetVerificationCodeBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVerificationCodeBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeBatches>>
  > = ({ signal }) =>
    getVerificationCodeBatches(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerificationCodeBatches>>
>;
export type GetVerificationCodeBatchesQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeBatches<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetVerificationCodeBatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeBatches>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatches<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeBatches>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatches<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all Verification Code Batches
 */

export function useGetVerificationCodeBatches<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerificationCodeBatchesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetVerificationCodeBatchesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVerificationCodeBatchesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeBatches>>
  > = ({ signal }) =>
    getVerificationCodeBatches(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeBatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeBatchesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerificationCodeBatches>>
>;
export type GetVerificationCodeBatchesSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeBatchesSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetVerificationCodeBatchesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchesSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchesSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all Verification Code Batches
 */

export function useGetVerificationCodeBatchesSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatches>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetVerificationCodeBatchesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerificationCodeBatchesSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new batch
 * @summary Creates a new batch
 */
export type verificationCodeCreateResponse = {
  data: VerificationCodeBatchListItemDTO;
  status: number;
};

export const getVerificationCodeCreateUrl = () => {
  return `http://localhost:8080/platform/v1/verification-codes/batches`;
};

export const verificationCodeCreate = async (
  verificationCodeCreateBody: VerificationCodeCreateBody,
  options?: RequestInit
): Promise<verificationCodeCreateResponse> => {
  const formData = new FormData();
  formData.append("file", verificationCodeCreateBody.file);
  formData.append("name", verificationCodeCreateBody.name);
  formData.append("validUntil", verificationCodeCreateBody.validUntil);

  return customFetchInstance<Promise<verificationCodeCreateResponse>>(
    getVerificationCodeCreateUrl(),
    {
      ...options,
      method: "POST",
      body: formData,
    }
  );
};

export const getVerificationCodeCreateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeCreate>>,
    TError,
    { data: VerificationCodeCreateBody },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationCodeCreate>>,
  TError,
  { data: VerificationCodeCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationCodeCreate>>,
    { data: VerificationCodeCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return verificationCodeCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerificationCodeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationCodeCreate>>
>;
export type VerificationCodeCreateMutationBody = VerificationCodeCreateBody;
export type VerificationCodeCreateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new batch
 */
export const useVerificationCodeCreate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeCreate>>,
    TError,
    { data: VerificationCodeCreateBody },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verificationCodeCreate>>,
  TError,
  { data: VerificationCodeCreateBody },
  TContext
> => {
  const mutationOptions = getVerificationCodeCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a specific verification codes batch by id
 * @summary Returns a specific verification codes batch
 */
export type getVerificationCodeByIdResponse = {
  data: VerificationCodeBatchListItemDTO;
  status: number;
};

export const getGetVerificationCodeByIdUrl = (batchId: string) => {
  return `http://localhost:8080/platform/v1/verification-codes/batches/${batchId}`;
};

export const getVerificationCodeById = async (
  batchId: string,
  options?: RequestInit
): Promise<getVerificationCodeByIdResponse> => {
  return customFetchInstance<Promise<getVerificationCodeByIdResponse>>(
    getGetVerificationCodeByIdUrl(batchId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetVerificationCodeByIdQueryKey = (batchId: string) => {
  return [
    `http://localhost:8080/platform/v1/verification-codes/batches/${batchId}`,
  ] as const;
};

export const getGetVerificationCodeByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVerificationCodeByIdQueryKey(batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeById>>
  > = ({ signal }) =>
    getVerificationCodeById(batchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!batchId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerificationCodeById>>
>;
export type GetVerificationCodeByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeById<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeById<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeById<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific verification codes batch
 */

export function useGetVerificationCodeById<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerificationCodeByIdQueryOptions(batchId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetVerificationCodeByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVerificationCodeByIdQueryKey(batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeById>>
  > = ({ signal }) =>
    getVerificationCodeById(batchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!batchId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerificationCodeById>>
>;
export type GetVerificationCodeByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeByIdSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeByIdSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeByIdSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific verification codes batch
 */

export function useGetVerificationCodeByIdSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerificationCodeByIdSuspenseQueryOptions(
    batchId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a specific Verification Code Batch by ID.
 * @summary Deletes a specific Verification Code Batch.
 */
export type deleteBatchByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeleteBatchByIdUrl = (batchId: string) => {
  return `http://localhost:8080/platform/v1/verification-codes/batches/${batchId}`;
};

export const deleteBatchById = async (
  batchId: string,
  options?: RequestInit
): Promise<deleteBatchByIdResponse> => {
  return customFetchInstance<Promise<deleteBatchByIdResponse>>(
    getDeleteBatchByIdUrl(batchId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeleteBatchByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBatchById>>,
    TError,
    { batchId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBatchById>>,
  TError,
  { batchId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBatchById>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return deleteBatchById(batchId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBatchByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBatchById>>
>;

export type DeleteBatchByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific Verification Code Batch.
 */
export const useDeleteBatchById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBatchById>>,
    TError,
    { batchId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBatchById>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getDeleteBatchByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns all batches matching the filter criteria. All given filters will be combined as AND criteria.
 * @summary Returns a batch via download
 */
export type getVerificationCodeBatchByIdDownloadResponse = {
  data: Blob;
  status: number;
};

export const getGetVerificationCodeBatchByIdDownloadUrl = (batchId: string) => {
  return `http://localhost:8080/platform/v1/verification-codes/batches/${batchId}/download`;
};

export const getVerificationCodeBatchByIdDownload = async (
  batchId: string,
  options?: RequestInit
): Promise<getVerificationCodeBatchByIdDownloadResponse> => {
  return customFetchInstance<
    Promise<getVerificationCodeBatchByIdDownloadResponse>
  >(getGetVerificationCodeBatchByIdDownloadUrl(batchId), {
    ...options,
    method: "GET",
  });
};

export const getGetVerificationCodeBatchByIdDownloadQueryKey = (
  batchId: string
) => {
  return [
    `http://localhost:8080/platform/v1/verification-codes/batches/${batchId}/download`,
  ] as const;
};

export const getGetVerificationCodeBatchByIdDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVerificationCodeBatchByIdDownloadQueryKey(batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>
  > = ({ signal }) =>
    getVerificationCodeBatchByIdDownload(batchId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!batchId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeBatchByIdDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>
>;
export type GetVerificationCodeBatchByIdDownloadQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeBatchByIdDownload<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchByIdDownload<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchByIdDownload<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a batch via download
 */

export function useGetVerificationCodeBatchByIdDownload<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVerificationCodeBatchByIdDownloadQueryOptions(
    batchId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetVerificationCodeBatchByIdDownloadSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVerificationCodeBatchByIdDownloadQueryKey(batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>
  > = ({ signal }) =>
    getVerificationCodeBatchByIdDownload(batchId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!batchId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVerificationCodeBatchByIdDownloadSuspenseQueryResult =
  NonNullable<Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>>;
export type GetVerificationCodeBatchByIdDownloadSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetVerificationCodeBatchByIdDownloadSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchByIdDownloadSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetVerificationCodeBatchByIdDownloadSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a batch via download
 */

export function useGetVerificationCodeBatchByIdDownloadSuspense<
  TData = Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVerificationCodeBatchByIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetVerificationCodeBatchByIdDownloadSuspenseQueryOptions(
      batchId,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the information of the logged in user.

Can throw the following error codes:
`ERR_VERIFICATION_CODE_CUSTOMER_RECENTLY_INVITED`
`ERR_VERIFICATION_CODE_CHAIN_NUMBER_USED_IN_OTHER_INVITE`
`ERR_SCL_CHAIN_NUMBER_ALREADY_REGISTERED`
`ERR_SCL_CHAIN_NUMBER_UNKNOWN`

Further explanation about the error codes can be found in the projects README.

 * @summary Creates a new verification code invite email
 */
export type verificationCodeInviteCreateResponse = {
  data: VerificationCodeInviteCreateResponseDTO;
  status: number;
};

export const getVerificationCodeInviteCreateUrl = () => {
  return `http://localhost:8080/platform/v1/verification-codes/invites/create`;
};

export const verificationCodeInviteCreate = async (
  verificationCodeInviteCreateDTO: VerificationCodeInviteCreateDTO,
  options?: RequestInit
): Promise<verificationCodeInviteCreateResponse> => {
  return customFetchInstance<Promise<verificationCodeInviteCreateResponse>>(
    getVerificationCodeInviteCreateUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(verificationCodeInviteCreateDTO),
    }
  );
};

export const getVerificationCodeInviteCreateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ApiErrorDTO
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteCreate>>,
    TError,
    { data: VerificationCodeInviteCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationCodeInviteCreate>>,
  TError,
  { data: VerificationCodeInviteCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationCodeInviteCreate>>,
    { data: VerificationCodeInviteCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return verificationCodeInviteCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerificationCodeInviteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationCodeInviteCreate>>
>;
export type VerificationCodeInviteCreateMutationBody =
  VerificationCodeInviteCreateDTO;
export type VerificationCodeInviteCreateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | ApiErrorDTO
  | InternalServerErrorResponse;

/**
 * @summary Creates a new verification code invite email
 */
export const useVerificationCodeInviteCreate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ApiErrorDTO
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteCreate>>,
    TError,
    { data: VerificationCodeInviteCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verificationCodeInviteCreate>>,
  TError,
  { data: VerificationCodeInviteCreateDTO },
  TContext
> => {
  const mutationOptions =
    getVerificationCodeInviteCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Applies an existing verification code to connect an audiologist with a supplier. Can throw the following error codes:
`ERR_VERIFICATION_CODE_INVALID_CODE`, `ERR_VERIFICATION_CODE_ALREADY_USED_CODE_FROM_BATCH`

The verificationCode will be validated against the following regex expression in both, frontend and backend: `^\d{4}-\d{4}-\d{4}-\d{4}$`
If the verificationCode violates against this regex, the error code `ERR_VERIFICATION_CODE_INVALID_CODE` will be thrown.

If the audiologist has already applied a code from the same batch, the error code `ERR_VERIFICATION_CODE_ALREADY_USED_CODE_FROM_BATCH` will be thrown.

Further explanation about the error codes can be found in the projects README.

 * @summary Applies an existing verification code
 */
export type verificationCodeInviteApplyResponse = {
  data: VerificationCodeUseResponseDTO;
  status: number;
};

export const getVerificationCodeInviteApplyUrl = () => {
  return `http://localhost:8080/platform/v1/verification-codes/invites/apply`;
};

export const verificationCodeInviteApply = async (
  verificationCodeUseDTO: VerificationCodeUseDTO,
  options?: RequestInit
): Promise<verificationCodeInviteApplyResponse> => {
  return customFetchInstance<Promise<verificationCodeInviteApplyResponse>>(
    getVerificationCodeInviteApplyUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(verificationCodeUseDTO),
    }
  );
};

export const getVerificationCodeInviteApplyMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteApply>>,
    TError,
    { data: VerificationCodeUseDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationCodeInviteApply>>,
  TError,
  { data: VerificationCodeUseDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationCodeInviteApply>>,
    { data: VerificationCodeUseDTO }
  > = (props) => {
    const { data } = props ?? {};

    return verificationCodeInviteApply(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerificationCodeInviteApplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationCodeInviteApply>>
>;
export type VerificationCodeInviteApplyMutationBody = VerificationCodeUseDTO;
export type VerificationCodeInviteApplyMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Applies an existing verification code
 */
export const useVerificationCodeInviteApply = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteApply>>,
    TError,
    { data: VerificationCodeUseDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verificationCodeInviteApply>>,
  TError,
  { data: VerificationCodeUseDTO },
  TContext
> => {
  const mutationOptions =
    getVerificationCodeInviteApplyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Checks if a verification code is valid and can be used to invite an audiologist by one or multiple suppliers.

Can throw the following error codes:
`ERR_VERIFICATION_CODE_INVALID_CODE`

Further explanation about the error codes can be found in the projects README.

 * @summary checks if a verification code is valid
 */
export type verificationCodeInviteCheckResponse = {
  data: VerificationCodeInviteCheckResponseDTO;
  status: number;
};

export const getVerificationCodeInviteCheckUrl = () => {
  return `http://localhost:8080/platform/v1/verification-codes/invites/check`;
};

export const verificationCodeInviteCheck = async (
  verificationCodeUseDTO: VerificationCodeUseDTO,
  options?: RequestInit
): Promise<verificationCodeInviteCheckResponse> => {
  return customFetchInstance<Promise<verificationCodeInviteCheckResponse>>(
    getVerificationCodeInviteCheckUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(verificationCodeUseDTO),
    }
  );
};

export const getVerificationCodeInviteCheckMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteCheck>>,
    TError,
    { data: VerificationCodeUseDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationCodeInviteCheck>>,
  TError,
  { data: VerificationCodeUseDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationCodeInviteCheck>>,
    { data: VerificationCodeUseDTO }
  > = (props) => {
    const { data } = props ?? {};

    return verificationCodeInviteCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerificationCodeInviteCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationCodeInviteCheck>>
>;
export type VerificationCodeInviteCheckMutationBody = VerificationCodeUseDTO;
export type VerificationCodeInviteCheckMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary checks if a verification code is valid
 */
export const useVerificationCodeInviteCheck = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationCodeInviteCheck>>,
    TError,
    { data: VerificationCodeUseDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verificationCodeInviteCheck>>,
  TError,
  { data: VerificationCodeUseDTO },
  TContext
> => {
  const mutationOptions =
    getVerificationCodeInviteCheckMutationOptions(options);

  return useMutation(mutationOptions);
};
